import { setSentryUser, addSentryContext } from '@/config/sentry.config'
export const namespaced = true
export const state = {
    sentryInitialized: false,
}

export const mutations = {
    SET_SENTRY_INITIALIZED(state, initialized) {
        state.sentryInitialized = initialized
    },
}

export const actions = {
    updateSentryUser(_, user) {
        if (user) {
            setSentryUser({
                id: user.sub,
                email: user.email,
                username: user.name || user.nickname,
                ...user,
            })

            // Add additional context
            addSentryContext('user', {
                authenticated: true,
                roles: user['https://mydocport.com/roles'] || [],
                permissions: user['https://mydocport.com/permissions'] || [],
            })
        } else {
            setSentryUser(null)
            addSentryContext('user', {
                authenticated: false,
            })
        }
    },

    addSentryContext(_, { key, context }) {
        addSentryContext(key, context)
    },

    initializeSentry({ commit }) {
        commit('SET_SENTRY_INITIALIZED', true)
    },
}

export const getters = {
    sentryInitialized: state => state.sentryInitialized,
}
